<div class="payment-aborted-container d-flex flex-column gap-4">
  <button type="button" class="btn btn-primary home-btn" (click)="onClick()">
    <i class="fa-solid fa-house me-2"></i>Home
  </button>

  <div class="payment-container gap-4 card p-3">
    <div class="d-flex flex-column payment-info">
      <span class="title"
        >Payment Collections aborted. PAC is partially paid</span
      >
      <span class="sub-title"
        >A partial payment for PAC might not be accepted and might be refunded.
        Please enter details for refund process.</span
      >
    </div>


    @if(!paymentCollected) {
      <div class="payment-container-info d-flex flex-column">
        <div class="payment-details d-flex flex-column gap-4">
          <div class="heading">Choose refund method:</div>

          <div class="gap-4 d-flex flex-column">
            <div class="payment-method-wrapper d-flex flex-column">
              <div
                class="payment-method p-3 d-flex align-items-center gap-3"
                (click)="onSelectMethod('payNow')"
                (keydown)="handleDropdownKey($event)"
              >
                <img src="assets/images/PayNow.png" alt="PayNow Icon" />
                <span>PayNow</span>
              </div>

              @if(selectedPaymentMethod === 'payNow') {
                <div class="d-flex flex-column gap-3 details">
                  <div class="pay-now-details">
                    <span class="primary-text">PayNow ID:</span> <span class="secondary-text"> Refund will be processed
                      via PayNow linked to SXXXX892C </span>
                  </div>

                  <button type="button" class="btn btn-primary align-self-end">Submit</button>
                </div>
              }
            </div>

            <div class="payment-method-wrapper d-flex flex-column">
              <div
                class="payment-method p-3 d-flex align-items-center gap-3"
                (click)="onSelectMethod('bank')"
                (keydown)="handleDropdownKey($event)"
              >
                <img src="assets/images/cheque-icon.png" alt="Cheque Icon" />
                <span>Bank Transfer</span>
              </div>
              @if(selectedPaymentMethod === 'bank') {
                <div class="details d-flex gap-4 flex-column">
                  <div class="">
                    <div class="d-flex gap-3">
                      <div class="cheque-information d-flex flex-column gap-2">
                        <div class="form-group"> <label for="bank-account-number" class="col-form-label">Bank Account Number</label> <input
                            id="bank-account-number" class="form-control form-control-md vkeyboard" type="text" spellcheck="false"
                            placeholder="Enter Bank Account Number" data-ms-editor="true"> </div>
                        <div class="form-group"> <label for="bank-name" class="col-form-label">Bank Name</label> <input
                            id="bank-name" class="form-control form-control-md vkeyboard" type="text" spellcheck="false" placeholder="Enter Bank Name"
                            data-ms-editor="true"> </div>
                      </div>
                    </div>
                  </div>
                  <button type="button" class="btn btn-primary align-self-end">Submit</button>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }

    @if(paymentCollected) {
      <div class="collection-container-info d-flex flex-column">
        <div class="payment-details d-flex flex-column gap-4">
          <div class="heading">Collected amount in this transaction:</div>

          <div class="table-responsive d-none d-sm-block">
            <table class="table" aria-label="Collected amount in this transaction:">
              <thead>
                <tr>
                  <th scope="col">Transaction Reference</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Payment Method</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                   RT-001205
                  </td>
                  <td>$ 150.00</td>
                  <td>PayNow</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
          class="table-mobile-container d-flex flex-column gap-2 d-block d-sm-none"
        >
          <div class="row-mobile d-flex align-items-center">
            <div class="info-container d-flex flex-column gap-1">
                <span class="reference">RT-002105</span>
                <span class="method">PayNow</span>
            </div>
            <span class="amount">$ 150.00</span>
          </div>
        </div>
        </div>
      </div>
    }
  </div>
</div>

<app-virtual-keyboard></app-virtual-keyboard>

